import { render, staticRenderFns } from "./NavBarAiChat.vue?vue&type=template&id=157a73b3&scoped=true"
import script from "./NavBarAiChat.vue?vue&type=script&lang=js"
export * from "./NavBarAiChat.vue?vue&type=script&lang=js"
import style0 from "./NavBarAiChat.vue?vue&type=style&index=0&id=157a73b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a73b3",
  null
  
)

export default component.exports